// Export paths to the generated preview images
// These paths are relative to the 'public' directory,
// so they can be used directly in `src` attributes.

export const previewImages = {
  findRep: '/images/previews/find-rep-preview.png',
  compare: '/images/previews/compare-reps-preview.png',
  quiz: '/images/previews/quiz-preview.png',
  pickViews: '/images/previews/pick-views-preview.png'
};